import React, { useMemo, useState, useCallback } from "react";
import { Box, Button, Checkbox, Typography, Chip } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import checkPermission from "../Utils/checkPermission";
import Pagination from "@mui/material/Pagination";
import { useTable, usePagination } from "react-table";
import "./BillingTable.css";

const BillingTable = ({ data, onDelete, onViewBill, onSelectionChange }) => {
  const [selectedIds, setSelectedIds] = useState([]);


 console.log("BillingTable data");
  console.table(
    data.map((item) => ({
      hostel: item.hostelName,
      hosteler: item.hostelerName,
      hostelerId: item.hostelerId,
      id: item.id,
      billStatus: item.billStatus,
    }))
  );
  
  const handleSelectOne = useCallback(
    (id) => {
      setSelectedIds((prev) => {
        const updated = prev.includes(id)
          ? prev.filter((item) => item !== id)
          : [...prev, id];

        onSelectionChange(updated);
        return updated;
      });
    },
    [onSelectionChange]
  );

  // ✅ FIXED: statusColorMap moved inside useMemo
  const columns = useMemo(() => {
    const statusColorMap = {
      COMPLETED: "success",
      FAILED: "error",
      PARTIALLY_COMPLETED: "warning",
      PAYMENT_INITIATED: "info",
    };

    return [
      {
        id: "checkbox",
        Header: "Select",
        accessor: "checkbox",
       Cell: ({ row }) => {
  const rowKey = row.original.id ?? row.original.hostelerId;

  return (
    <Checkbox
      size="small"
      checked={selectedIds.includes(rowKey)}
      onClick={(e) => e.stopPropagation()}
      onChange={() => handleSelectOne(rowKey)}
    />
  );
},
      },
      { Header: "Hostel Name", accessor: "hostelName" },
      { Header: "Hosteler Name", accessor: "hostelerName" },
      { Header: "Mobile Number", accessor: "hostelerPhoneNumber" },
      { Header: "Billing Month", accessor: "billingMonth" },
   {
  Header: "Payment Status",
  accessor: "paymentStatus",
  Cell: ({ row, value }) => {
    const { id, billStatus } = row.original;

    let label = "";
    let color = "default";

    if (id == null) {
      if (billStatus === "NOT_GENERATED") {
        label = "Bill Not Generated";
        color = "warning";
      } else if (billStatus === "OUTSIDE_BILLING_PERIOD") {
        label = "Outside Billing Period";
        color = "default";
      } else {
        label = "Bill Not Generated";
      }
    } else {
      label = value?.replaceAll("_", " ") || "";
      color = statusColorMap[value] || "default";
    }

    return (
      <Chip
        label={label}
        color={color}
        size="small"
        sx={{
          height: 24,
          fontSize: "0.75rem",
          fontWeight: 500,
          borderRadius: "6px",
        }}
      />
    );
  },
},
      {
        id: "actions",
        Header: "Actions",
        Cell: ({ row }) => (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Button
              disabled={
    !checkPermission("Hostel", "Hosteler Bill", "VIEW") ||
    row.original.id == null
  }
              variant="outlined"
              size="small"
              color="success"
              onClick={() => onViewBill(row.original)}
              startIcon={<ReceiptIcon sx={{ fontSize: 16 }} />}
              sx={{
  minWidth: { xs: 70, sm: 80 },
  height: 34,
  fontSize: "0.8rem",
  textTransform: "none",
  borderRadius: 1.5,
}}
            >
              View
            </Button>

            <Button
              disabled={
    !checkPermission("Hostel", "Hosteler Bill", "DELETE") ||
    row.original.id == null
  }
              variant="outlined"
              size="small"
              color="error"
              onClick={() => onDelete(row.original.id)}
              sx={{
  minWidth: { xs: 60, sm: 80 },
  height: 32,
  fontSize: "0.8rem",
  textTransform: "none",
}}
            >
              Delete
            </Button>
          </Box>
        ),
      },
    ];
  }, [selectedIds, handleSelectOne, onDelete, onViewBill]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    pageCount,
    state: { pageIndex, pageSize },
    setPageSize,
  } = useTable(
  {
    columns,
    data,
    getRowId: (row) => String(row.id ?? row.hostelerId),
    initialState: {
      pageIndex: 0,
      pageSize: 5,
    },
  },
  usePagination
);

  return (
    <div className="billing-list">
      <Typography
  variant="h6"
  sx={{
    mb: 1,
    fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
    fontWeight: 600,
  }}
>
  Billing List
</Typography>

      <div className="table-container">
        <table {...getTableProps()} className="table">
          <thead>
            {headerGroups.map((hg) => (
              <tr {...hg.getHeaderGroupProps()} key={hg.id}>
                {hg.headers.map((column) => (
                  <th {...column.getHeaderProps()} key={column.id}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.length === 0 ? (
              <tr>
                <td colSpan={7} className="no-data">
                  No records found.
                </td>
              </tr>
            ) : (
              page.map((row) => {
                prepareRow(row);
				console.log("Rendering:", row.original.hostelerName);
const rowKey = row.original.id ?? row.original.hostelerId;

const rowProps = row.getRowProps();

console.log({
  rowId: row.id,
  rowProps,
  rowKey,
  hostelerName: row.original.hostelerName,
});
                return (
                  <tr
                    {...row.getRowProps()}
                    key={rowKey}
                    onClick={(e) => {
                      // ✅ prevent clicks on buttons/checkbox
                      if (
                        e.target.closest("button") ||
                        e.target.closest("input")
                      )
                        return;

                      handleSelectOne(rowKey);
                    }}
                  >
                    {row.cells.map((cell) => (
                      <td
                        {...cell.getCellProps()}
                        key={cell.column.id}
                        data-label={
                          cell.column.id === "actions" ||
                          cell.column.id === "checkbox"
                            ? ""
                            : cell.column.Header || ""
                        }
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>

        {data.length > 0 && (
          <Box
  className="pagination-box"
  sx={{
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "space-between",
    alignItems: "center",
    gap: 1.5,
    mt: 2,
  }}
>
            <Pagination
              count={pageCount}
              page={pageIndex + 1}
              onChange={(e, value) => gotoPage(value - 1)}
              color="primary"
              size="small"
            />

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2">Rows:</Typography>
              <select
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
              >
                {[5, 10, 15, 20].map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </Box>
          </Box>
        )}
      </div>
    </div>
  );
};

export default BillingTable;